import type { FC, PropsWithChildren } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledHeaderContainer, StyledHeaderDescription, StyledHeaderTitle } from "./styles";

type ListPageHeaderProps = {
    title: Readonly<Translatable>;
    description: Readonly<Translatable>;
};

const ScoringSettingsPageHeader: FC<PropsWithChildren<ListPageHeaderProps>> = ({ title, description, children }) => {
    return (
        <StyledHeaderContainer
            gap="8px"
            justifyContent="space-between"
            alignItems="center"
        >
            <Flex
                flexDirection="column"
                gap="4px"
                justifyContent="flex-start"
            >
                <I18n
                    translatable={title}
                    element={StyledHeaderTitle}
                />
                <I18n
                    translatable={description}
                    element={StyledHeaderDescription}
                />
            </Flex>
            {children}
        </StyledHeaderContainer>
    );
};

export default ScoringSettingsPageHeader;
